import * as Sentry from "@sentry/nuxt";

Sentry.init({
  dsn: "https://32e7830858b3022997952e666840e139@log.compentum.de/13",

  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
});
